// Campaign status shown to the user is `effective_status`, which the backend
// derives from start_date / end_date on every read. `campaign_status` is the
// stored value an admin set and must never be displayed, nor overwritten with
// the derived one ("Upcoming" is not a valid stored status).
// The fallback keeps older payloads that predate effective_status readable.
export const getCampaignStatus = (campaign) =>
  campaign?.effective_status || campaign?.campaign_status || "";

const CAMPAIGN_STATUS_COLORS = {
  Active: { bgcolor: "#83E542", color: "#fff" },
  Upcoming: { bgcolor: "#4C9AFF", color: "#fff" },
  Closed: { bgcolor: "#8C8C8C", color: "#fff" },
  Inactive: { bgcolor: "#FF625F", color: "#fff" },
  "Under Review": { bgcolor: "#FFC107", color: "#fff" },
};

export const getCampaignStatusColor = (status) =>
  CAMPAIGN_STATUS_COLORS[status] || { bgcolor: "#FFC107", color: "#fff" };
